import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_group = _resolveComponent("link-group")!
  const _component_project_list = _resolveComponent("project-list")!
  const _component_project_detail = _resolveComponent("project-detail")!

  return (_openBlock(), _createElementBlock("div", {
    id: "root",
    class: _normalizeClass({fixed: _ctx.fixed}),
    ref: "app"
  }, [
    _createElementVNode("header", null, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Hello there.", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, [
        _createTextVNode("I'm Haoyuan Liu, "),
        _createElementVNode("br"),
        _createTextVNode("a Software Engineer at Meta.")
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "I build software for an open web.", -1)),
      _createVNode(_component_link_group, { links: _ctx.links }, null, 8, ["links"])
    ]),
    _createVNode(_component_project_list, { onDetail: _ctx.onDetail }, null, 8, ["onDetail"]),
    (_ctx.detail)
      ? (_openBlock(), _createBlock(_component_project_detail, {
          key: 0,
          onDismiss: _ctx.onDismiss,
          project: _ctx.detail
        }, null, 8, ["onDismiss", "project"]))
      : _createCommentVNode("", true)
  ], 2))
}